import React from 'react';
import '../../styles/App.css';
import '../../styles/Table.css'
import '../../styles/Selectors.css'

import HardwareDependencySelector from "./HardwareDependencySelector";
import CalibrationTable from "./CalibrationTable";
import CompleteHistory from "./CompleteHistory";

/**
 * Class used for rendering and handling selections for NAOVIN Modules
 *
 * @author Ethan Jones
 */
class ModuleSelector extends React.Component{

    state ={
        renderCalibrationTable: false,
        renderHardwareDependencies: false,
        moduleId: null,
        hardwareDepIndex: null,
        renderCompleteHistory: false,
        hardwareList: null,
    }

    /**
     * I dont remember if this is actually a necessary method
     * @returns {Promise<void>}
     */
    async getHardwareListForCompleteHistory(){
        if(this.props.progSeqData.isChildrenSequence){
            Object.keys(this.props.progSeqData.sequenceDependencyDataHardwareList[this.props.childId])
                .map(async data => {
                    if (this.props.progSeqData.sequenceDependencyDataHardwareList[this.props.childId][data].length === 1)
                        await this.setState({
                            hardwareList: this.props.progSeqData.sequenceDependencyDataHardwareList[this.props.childId][data]
                        })
                    else {
                        let hardwareListArray = []
                        await this.props.progSeqData.sequenceDependencyDataHardwareList[this.props.childId][data].map((async dataArray => {
                            hardwareListArray.concat(dataArray)
                        }))
                        await this.setState({
                            hardwareList: hardwareListArray
                        })
                    }
                })
        }
        else{
            Object.keys(this.props.progSeqData.dependencyDataHardwareList).map(async data => {
                if (this.props.progSeqData.dependencyDataHardwareList[data].length === 1) {
                    await this.setState({
                        hardwareList: this.props.progSeqData.dependencyDataHardwareList[data]
                    })
                } else {
                    let hardwareListArray = []
                    await this.props.progSeqData.dependencyDataHardwareList[data].map((async dataArray => {
                        hardwareListArray.concat(dataArray)
                    }))
                    await this.setState({
                        hardwareList: hardwareListArray
                    })
                }
            })
        }

    }

    /**
     * Handler used for when user selects a module
     * @param e selected module
     * @returns {Promise<void>}
     */
    async handleModuleSelection(e){
        let module = await e.split(",")
        await this.props.turnOffDisplay()
        if(e === "Complete History"){
            this.props.cmplHisHandler()
        }
        else {
            this.props.calHandler(module[0], module[1], this.props.progSeqData.calibrationData[module[0]])
        }
    }

    /**
     * Iterate through modules and dis[lay the names in a dropdown selector
     *
     * @returns {*}
     */
    renderModuleSelector(){
        return(
            <select className={"moduleSelector"} onChange={e=>this.handleModuleSelection(e.target.value)}>
                <option>Complete History</option>
                {this.props.modules.map((data,index)=>(
                    <option value={data}>{
                        (data[0].length ===1 ? ("0"+data[0]):(data[0]))+" - "+data[1]
                    }
                    </option>
                ))}
            </select>
        )
    }

    /**
     * Main render method for ModuleSelector
     * @returns {*}
     */
    render(){
        if(this.props.progSeqData.isChildrenSequence) {
            if (this.props.progSeqData.hasDependency) {
                if(this.state.hardwareList === null)
                    this.getHardwareListForCompleteHistory()
                if(this.state.hardwareList.length === 0) {
                    if (this.state.renderHardwareDependencies) {
                        return (
                            <React.Fragment>
                                <React.Fragment>
                                    {this.state.renderCompleteHistory ? (
                                        <CompleteHistory progSeqData={this.props.progSeqData}
                                                         modules={this.props.progSeqData.sequenceModuleData[this.props.childId]}
                                                         chainOfParts={this.props.progSeqData.sequenceCalibrationData[this.props.childId]}
                                                         hardwareList={this.props.progSeqData.sequenceDependencyDataHardwareList[this.props.childId][this.state.moduleId]}
                                                         hwdCopMap={this.props.progSeqData.sequenceDependencyDataCopMap[this.props.childId]}
                                                         hasDependency={this.props.progSeqData.sequenceDependencyDataExists[this.props.childId]}/>
                                    ) : (
                                        <div></div>
                                    )}
                                </React.Fragment>
                                {this.renderModuleSelector()}
                                <HardwareDependencySelector modId={this.state.moduleId}
                                                            hardwareList={this.props.progSeqData.sequenceHardwareDependencyListMap[this.props.childId][this.state.hardwareDepIndex][1]}
                                                            progSeqData={this.props.progSeqData}
                                                            childId={this.props.childId}/>
                            </React.Fragment>)
                    } else {
                        return (
                            <React.Fragment>
                                <React.Fragment>
                                    {this.state.renderCompleteHistory ? (
                                        <CompleteHistory progSeqData={this.props.progSeqData}
                                                         modules={this.props.progSeqData.sequenceModuleData[this.props.childId]}
                                                         chainOfParts={this.props.progSeqData.sequenceCalibrationData[this.props.childId]}
                                                         hardwareList={this.props.progSeqData.sequenceDependencyDataHardwareList[this.props.childId][this.state.moduleId]}
                                                         hwdCopMap={this.props.progSeqData.sequenceDependencyDataCopMap[this.props.childId]}
                                                         hasDependency={this.props.progSeqData.sequenceDependencyDataExists[this.props.childId]}/>
                                    ) : (
                                        <div></div>
                                    )}
                                </React.Fragment>
                                {this.renderModuleSelector()}
                                {this.state.renderCalibrationTable ? (
                                    <React.Fragment>
                                        <CalibrationTable
                                            chainOfParts={this.props.progSeqData.sequenceCalibrationData[this.props.childId][this.state.moduleId]}
                                            hasDependency={false} progSeqData={this.props.progSeqData}
                                            childId={this.props.childId}
                                        />
                                    </React.Fragment>
                                ) : (
                                    <div></div>
                                )}
                            </React.Fragment>
                        )
                    }
                }
            }
            else{
                return(
                    <React.Fragment>
                    <React.Fragment>
                        {this.state.renderCompleteHistory ? (
                            <CompleteHistory progSeqData = {this.props.progSeqData}
                                             modules = {this.props.progSeqData.sequenceModuleData[this.props.childId]}
                                             chainOfParts = {this.props.progSeqData.sequenceCalibrationData[this.props.childId]}
                            />
                        ) : (
                            <div></div>
                        )}
                    </React.Fragment>
                <form>
                </form>{this.renderModuleSelector()}
                {this.state.renderCalibrationTable ? (
                    <div>
                        <CalibrationTable
                            chainOfParts={this.props.progSeqData.sequenceCalibrationData[this.props.childId][this.state.moduleId]}
                            hasDependency={false} progSeqData={this.props.progSeqData}
                            childId={this.props.childId}
                        />
                    </div>
                ) : (
                    <div></div>
                )}</React.Fragment>
                )
                }

        }
        if(!this.props.progSeqData.isChildrenSequence){
            if(this.props.progSeqData.hasDependency){
                if(this.state.hardwareList === null)
                    this.getHardwareListForCompleteHistory()
                if(this.state.renderHardwareDependencies){
                    return(
                        <React.Fragment>
                        <React.Fragment>
                            {this.state.renderCompleteHistory ?(
                                <CompleteHistory progSeqData = {this.props.progSeqData}
                                                 modules = {this.props.progSeqData.moduleData}
                                                 chainOfParts = {this.props.progSeqData.calibrationData}
                                                 hardwareList = {this.state.hardwareList}
                                                 hwdCopMap = {this.props.progSeqData.dependencyDataCopMap}
                                                 hasDependency = {this.props.progSeqData.dependencyDataExists}/>
                            ):(
                                <div></div>
                            )}
                        </React.Fragment>
                        {this.renderModuleSelector()}
                        <HardwareDependencySelector modId={this.state.moduleId}
                                                    hardwareList={this.props.progSeqData.dependencyDataHardwareList[this.state.moduleId]}
                                                    progSeqData={this.props.progSeqData}/>
                    </React.Fragment>)
                }
                else {
                    return(
                        <React.Fragment>
                        <React.Fragment>
                            {this.state.renderCompleteHistory ?(
                                <CompleteHistory progSeqData = {this.props.progSeqData}
                                                 modules = {this.props.progSeqData.moduleData}
                                                 chainOfParts = {this.props.progSeqData.calibrationData}
                                                 hardwareList = {this.props.progSeqData.dependencyDataHardwareList}
                                                 hwdCopMap = {this.props.progSeqData.dependencyDataCopMap}
                                                 hasDependency = {this.props.progSeqData.dependencyDataExists}/>
                            ):(
                                <div></div>
                            )}
                        </React.Fragment>
                        {this.renderModuleSelector()}
                        {this.state.renderCalibrationTable ? (
                            <div>
                                <CalibrationTable chainOfParts={this.props.progSeqData.calibrationData[this.state.moduleId]}
                                                  hasDependency={false} progSeqData={this.props.progSeqData}
                                />
                            </div>
                        ):(<div></div>)}
                    </React.Fragment>)
                }
            }

            else{
                return (
                    <div>
                        {!this.state.renderHardwareDependencies ? (
                            <React.Fragment>
                                <React.Fragment>
                                    {this.state.renderCompleteHistory ?(
                                        <CompleteHistory progSeqData = {this.props.progSeqData}
                                                         modules = {this.props.progSeqData.moduleData}
                                                         chainOfParts = {this.props.progSeqData.calibrationData}
                                        />
                                    ):(
                                        <div></div>
                                    )}
                                </React.Fragment>
                                {this.renderModuleSelector()}
                                {this.state.renderCalibrationTable ? (
                                    <div>
                                        <CalibrationTable chainOfParts={this.props.progSeqData.calibrationData[this.state.moduleId]}
                                                          hasDependency={false} progSeqData={this.props.progSeqData}
                                        />
                                    </div>
                                ) : (
                                    <div></div>
                                )}
                            </React.Fragment>
                        ) : (
                            <div></div>
                        )}
                    </div>
                )
            }

        }
    }
}



export default ModuleSelector;